// Shared display labels for the raw enum values the vault API returns, so the table
// and the drawer never disagree about what a document is.

export const CATEGORY_LABEL = {
  insurance: "Insurance",
  certificate: "Certificate",
  broadband: "Broadband",
  utilities: "Utilities",
  other: "Other",
};

// backend/models/vaultDocument.js extractionStatus. "success" on its own tells an
// admin nothing about whether the fields on screen are trustworthy.
//
// Wording follows what services/documentExtraction/index.js actually sets:
//   found === 4 -> success · found === 0 -> failed · otherwise -> partial
// so "all four" is a precise claim, not a flourish. `failed` covers BOTH an
// unreadable file and a readable one where nothing matched, which is why it says
// "no details found" rather than "could not read" — the accompanying extractionNote
// ("no text layer found", "could not read this file") distinguishes the two.
export const EXTRACTION_LABEL = {
  success: "All four details found",
  partial: "Some details found",
  failed: "No details found",
  not_attempted: "Not read automatically",
};

// Unknown values fall through to the raw string rather than rendering blank: the enum
// may gain a value before this file does.
export const labelFor = (map, value) => map[value] || value || "—";
